/**
 * @file index.tsx
 *
 * @fileoverview Renders the information for the job expiration when a extended runtime
 * product is being bought.
 */
import { addDays } from 'date-fns';
import React from 'react';
import { useIntl } from 'react-intl';
import { formatJobDate } from '~/jobiqo/services/jobs';
import { FormDescription } from '~/vcl/atoms/01-forms/11-form-item/02-form-description';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { CalendarIcon } from '~/vcl/icons/Calendar';

interface ExtendedRuntimeInfoProps {
  /**
   * The maximum job value (extend runtime plus the default duration).
   */
  maxValue?: number;
  /**
   * The current publishing date. if changed will be updated.
   */
  publishingDate: any;
}
export default function ExtendedRuntimeInfo({
  maxValue,
  publishingDate,
}: ExtendedRuntimeInfoProps) {
  const intl = useIntl();
  return (
    <>
      <FlexItems alignItems="baseline" gap={3}>
        <FlexItem>
          <CalendarIcon color="primary" />
        </FlexItem>
        <FlexItem>
          <FormDescription>
            {intl.formatMessage(
              {
                id: 'job_duration_runtime_expiration_days_online',
                defaultMessage: 'This job will be online for {daysOnline} days',
              },
              {
                daysOnline: <strong>{maxValue}</strong>,
              },
            )}
          </FormDescription>
        </FlexItem>
      </FlexItems>
      <Spacing />
      <FormDescription>
        {intl.formatMessage(
          {
            id: 'job_duration_runtime_expiration_datetime',
            defaultMessage:
              'Based on the start date and runtime, the job will go offline on {date} at {time}.',
          },
          {
            date: (
              <b>
                {formatJobDate(
                  addDays(new Date(publishingDate), Number(maxValue)),
                  intl,
                )}
              </b>
            ),
            time: <b>{intl.formatTime(new Date())}</b>,
          },
        )}
      </FormDescription>
    </>
  );
}
